<div class="grid-container">
  <div class="grid-x">
    <div class="cell small-12 bold">
      Schematics to Display:
    </div>
    @for (opt of displayOptions; track opt) {
      <div class="cell small-12">
        <input type="radio" [value]="opt.id" [checked]="componentData?.config?.display === opt.id" (change)="onCheckedChanged(opt.id)" /> {{opt.text}}
      </div>
    }
  </div>
</div>